import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { StateType } from "../../../../utils/types";
import { selectUsers } from "../../../../redux/admin/selector";
import { getUser, deleteUser } from "../../../../redux/admin/actions";
import { setCurrentStep } from "../../../../redux/shared/actions";

const mapStateToProps = (state: StateType) => ({
  users: selectUsers(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getUser,
      deleteUser,
      setCurrentStep,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
